module.exports = __webpack_public_path__ + "static/media/landingpage_p13.306dee8f.jpeg";